import * as yup from 'yup'

export class ClusterShipperThirdPartyConversionDeliveryDto {
  clusterShipperThirdPartyConversionDeliveryPhotoFileName?: string = undefined
  clusterShipperThirdPartyConversionDeliveryPhotoFile?: File = undefined
  dropOffDate?: string = undefined
}

export const clusterShipperThirdPartyConversionDeliveryValidationSchema = yup.object({
  clusterShipperThirdPartyConversionDeliveryPhotoFile: yup
    .mixed()
    .required('Third Party Conversion Delivery Photo is required.')
})
